import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { getAllNotifications, makeReadNotification } from '../actions/notifications'
import Logout from './logout'
import Notifications from './common/page_header/notifications'

const Navbar = (props) => {
  const [notificationsMenuOpen, setNotificationsMenuOpen] = useState(false)

  useEffect(() => {
    props.getAllNotifications()
  }, [])

  const handleNotificationsMenuClick = (isOn) => setNotificationsMenuOpen(!isOn)

  const getUnreadNotifications = () => {
    return props.data.results.filter((r) => r.state === 'pending' || r.state === 'delivered')
  }

  const makeRead = async ({ state, id }) => {
    if (state === 'pending') {
      await props.makeReadNotification(id)
    }
    setNotificationsMenuOpen(false)
    props.history.push('/notifications')
  }

  const { isAuthenticated, onLogoutClick, onNavigateHomeClick, company, isFetching, data } = props

  return (
    <>
      <div className='navbar navbar-static-top white-bg' style={{ marginBottom: 0, marginTop: 0 }}>
        <div className='navbar-header'>
          <ul
            aria-controls='navbar'
            aria-expanded='false'
            data-target='#navbar'
            data-toggle='dropdown'
            role='button'
            aria-haspopup='true'
            className='navbar-toggle collapsed'
            type='button'
          >
            <i className='fa fa-reorder' />
          </ul>
          <div
            onClick={onNavigateHomeClick}
            className='navbar-brand cursor-pointer'
            style={{ height: '40px', padding: '10px 0 0 25px', margin: 0 }}
          >
            <strong>
              Compliance Dashboard: <span className='animated fadeIn'>{company}</span>
            </strong>
          </div>
        </div>
        <ul
          className='nav navbar-top-links navbar-right'
          id='navbar'
          style={{
            color: 'gray',
            height: 60,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {!isFetching && data && (
            <Notifications
              data={getUnreadNotifications()}
              handleNotificationsMenuClick={handleNotificationsMenuClick}
              notificationsMenuOpen={notificationsMenuOpen}
              makeRead={makeRead}
            />
          )}
          {isAuthenticated && <Logout onLogoutClick={onLogoutClick} />}
        </ul>
      </div>
    </>
  )
}

const mapStateToProps = (state, ownProps) => ({
  errorMessage: state.getAllNotifications.errorMessage,
  data: state.getAllNotifications.results,
  isFetching: state.getAllNotifications.isFetching,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAllNotifications,
      makeReadNotification,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar))
